/* eslint-disable camelcase */
import MasterItemCollection from './MasterItemCollection';
import { FreeText, MonicaObject } from '../item';
import DocumentCollection from './DocumentCollection';

export class QuotationListCollection {
  arrayIndex: number;

  is_quote: boolean;

  name: string;

  floor: number;

  width: number | string;

  depth: number | string;

  height: number | string;

  area: string;

  unit: string;

  maker: string;

  part_number: string;

  item_set_date: string;

  note: string;

  item_name: string;

  unit_price: number | string;

  price: number | string;

  room_name: string;

  item_id: string;

  guid: string;

  end_item_info: MasterItemCollection;

  white_item_info: MasterItemCollection;

  snapWallId: string;

  item_sub_category: string;

  item: MonicaObject;

  isHabaki: boolean;

  intersectItem: string;

  parentPin: FreeText;

  rate: number;    // 入居者負担割合

  reason: string;  // 理由

  remarks: string; // 備考

  documents: DocumentCollection[];

  other_flag: boolean;

  other_text: string;

  is_auxiliary_data:boolean;
}

export default QuotationListCollection;
